module.exports = __webpack_public_path__ + "img/16-1.77654bfb.jpg";